import type { PropsWithChildren, ReactNode } from 'react';
import { PLACEHOLDERS } from '../../constants/pdf-preview.ts';
import { usePlaceholders } from '../placeholders-context.tsx';
import { Placeholder } from './internals/placeholder';
import styles from './additional-notes-placeholder.module.css';

interface AdditionalNotesPlaceholderProps {
  position: 'header' | 'footer';
}

export function AdditionalNotesPlaceholder({
  position,
  children,
}: PropsWithChildren<AdditionalNotesPlaceholderProps>): ReactNode {
  const { showPlaceholder } = usePlaceholders(
    position === 'header' ? PLACEHOLDERS.HeaderNotes : PLACEHOLDERS.FooterNotes
  );

  if (showPlaceholder) {
    if (position === 'header') {
      return (
        <div className={styles.notes}>
          <Placeholder width="79px" />
          <Placeholder width="197px" />
        </div>
      );
    }

    return (
      <div className={styles.notes}>
        <Placeholder width="145px" />
        <Placeholder width="60px" />
      </div>
    );
  }

  return <>{children}</>;
}
